import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
export const Badge = ({ children, value, hideZero }) => {
    if (value === 0 && !hideZero) {
        return children;
    }
    return (_jsxs("span", { className: "relative", children: [_jsx("span", { className: twMerge('focus:ring-ring bg-primary hover:bg-primary/80 py-0.25 absolute right-0 top-0 inline-flex -translate-y-1/2 translate-x-1/2 transform items-center rounded-full border border-transparent px-1.5 text-xs font-semibold text-white transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2'), children: value }), children] }));
};
//# sourceMappingURL=Badge.js.map